export enum MesocarpoProcessingStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETE = 'complete',
}

export function getMesocarpoProcessingLabel({
  status,
  shortName,
  helperText,
}: {
  status: MesocarpoProcessingStatus;
  shortName?: boolean;
  helperText?: boolean;
}): string {
  if (shortName) {
    switch (status) {
      case MesocarpoProcessingStatus.IN_PROGRESS:
        return 'Em andamento';
      case MesocarpoProcessingStatus.COMPLETE:
        return 'Beneficiamento finalizado';
    }
  }

  if (helperText) {
    switch (status) {
      case MesocarpoProcessingStatus.IN_PROGRESS:
        return 'O beneficiamento do mesocardo não está concluído.';
      case MesocarpoProcessingStatus.COMPLETE:
        return 'O mesocarpo já foi beneficiado e empacotado.';
    }
  }

  switch (status) {
    case MesocarpoProcessingStatus.IN_PROGRESS:
      return 'Em andamento';
    case MesocarpoProcessingStatus.COMPLETE:
      return 'Finalizado';
  }
}
